"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20Holder__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "erdstall",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "erdstall",
        outputs: [
            {
                internalType: "contract Erdstall",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "value",
                type: "bytes",
            },
        ],
        name: "transfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class ERC20Holder__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(erdstall, overrides) {
        return super.deploy(erdstall, overrides || {});
    }
    getDeployTransaction(erdstall, overrides) {
        return super.getDeployTransaction(erdstall, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ERC20Holder__factory = ERC20Holder__factory;
ERC20Holder__factory.bytecode = _bytecode;
ERC20Holder__factory.abi = _abi;
//# sourceMappingURL=ERC20Holder__factory.js.map